// extracted by mini-css-extract-plugin
var _1 = "styles-module__column___Ri7ay";
export { _1 as "column" }
